import * as React from 'react';
import styles from './NavBar.module.sass';
import NavigationItems from './NavigationItems/NavigationItems';
import { RouteComponentProps, withRouter } from 'react-router';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import { IAuthStore } from '../../mobx-store/storeInterfaces/authStoreInterface';
import { inject } from 'mobx-react';

interface IProps {
  authStore?: IAuthStore;
}
@inject('authStore')
class NavBar extends React.Component<IProps & RouteComponentProps, {}> {
   render() {
    return (
        // <nav className={styles.navBar}>
        //   <div className={styles.items}>
        //     <NavigationItems/>
        //     <div/>
        //   </div>
        // </nav>
        <div className={styles.navBar}>
             <List component='nav' className={styles.items}>
             <NavigationItems/>
             </List>
             <Divider />
             <Button
             variant='contained'
             size='small'
             color='primary'
             onClick={() => this.props.authStore!.signOut()}
             className = {styles.logoutButton}>
          Logout
        </Button>
             </div>
    );
  }
}

export default withRouter(NavBar);
